export const getAllPagesText = (
  totalPages: number,
  pagesAllowed: number,
  isPowerpoint: boolean
) => {
  if (totalPages < pagesAllowed) {
    return 'All';
  }

  return `${isPowerpoint ? 'Slides' : 'Pages'} 1-${pagesAllowed}`;
};

export const getAllPagesRange = (totalPages: number, pagesAllowed: number) => {
  const pages = totalPages < pagesAllowed ? totalPages : pagesAllowed;

  return Array.from(Array(pages), (_, x) => x + 1);
};
